export default {
	authorizeAndSaveButton: "Authorize and save",
	title: "New One-time Meeting",
	editTitle: "Edit One-time Meeting",
	saveButton: "Save",
	scheduleMeetingButton: "Schedule meeting",
	cancelButton: "Cancel",
	deleteButton: "Delete meeting",

	meetingNameLabel: "Meeting name",
	meetingLinkHint: "The Zoom or Meet link for this meeting. We'll automatically send Opre Assistant to your meeting.",
	meetingLinkLabel: "Meeting link",
	meetingFrequencyLabel: "Meeting frequency",
	meetingTemplateHint: "Adds the selected meeting template to each new instance.",
	meetingTemplateLabel: "Meeting template",
	meetingTemplatePlaceholder: "Select a template",
	noTemplateOptionText: "No template",
	timezoneLabel: "Time of day",
	startDateLabel: "Start date",

	sundayShortLabel: "Sun",
	mondayShortLabel: "Mon",
	tuesdayShortLabel: "Tue",
	wednesdayShortLabel: "Wed",
	thursdayShortLabel: "Thu",
	fridayShortLabel: "Fri",
	saturdayShortLabel: "Sat",

	sundayLongLabel: "Sunday",
	mondayLongLabel: "Monday",
	tuesdayLongLabel: "Tuesday",
	wednesdayLongLabel: "Wednesday",
	thursdayLongLabel: "Thursday",
	fridayLongLabel: "Friday",
	saturdayLongLabel: "Saturday",

	teamlessLabel: "Check this box to create a test 'teamless' meeting.",
};
